export default {
      id: "ic_agenda-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_agenda-usage",
      toString: function () {
        return this.url;
      }
    }